import { Pipe, PipeTransform } from '@angular/core';
import { paraUtc } from '../functions/paraUtc';

/**
 * Marca como UTC uma data que a API devolve sem indicador de fuso.
 * Use antes do DatePipe: {{ valor | dataUtc | date: 'dd/MM/yyyy HH:mm':'-0300' }}
 */
@Pipe({
  name: 'dataUtc',
  standalone: true
})
export class DataUtcPipe implements PipeTransform {
  transform(valor: Date | string | null | undefined): Date | null {
    if (!valor) return null;
    return paraUtc(valor);
  }
}
